import styles from '../components/app/app.scss';

export default function scrollParent() {
  return typeof window !== 'undefined'
    ? window.document.getElementsByClassName(styles.scrollable)[0] || window.document.body
    : null;
}
